import flatpickr from "flatpickr";
import { German } from "flatpickr/dist/l10n/de";
import { english } from "flatpickr/dist/l10n/default";
import { config } from "./Config";
import { format, differenceInYears } from "date-fns";
import { de, enUS } from "date-fns/locale";
import { getCurrentLocaleLang } from "./Helper";

const currentLocaleLang = getCurrentLocaleLang();
const locale = {
  de,
  enUS,
};

const pickerLocale = currentLocaleLang == "de" ? German : english;

export const formatDateWithLocale = (date, formatStr = "PP") => {
  const currentLocale = locale[currentLocaleLang] || enUs;
  return format(date, formatStr, {
    locale: currentLocale,
  });
};

export const getDatesDiffInYears = (date1, date2) => {
  return differenceInYears(date1, date2);
};

//@todo if we have datefn - maybe this class could be removed
class FilterDate {
  constructor(date) {
    this.date = date;
  }

  destructDate() {
    const year = this.date.getFullYear();
    const month = this.date.getMonth();
    const day = this.date.getDate();

    return { year, month, day };
  }

  removeYear(yearCount = 1) {
    const { year, month, day } = this.destructDate();
    const date = new Date(year - yearCount, month, day);
    date.setUTCHours(24, 0, 0, 0);
    return date;
  }

  currentValue() {
    return this.date;
  }
}

const CURRENT_DATE = new Date();
CURRENT_DATE.setUTCHours(0, 0, 0, 0);

const CURRENT_YTD_DATE = new Date(new Date().getFullYear(), 0, 1);
CURRENT_YTD_DATE.setUTCHours(24, 0, 0, 0);

const CHART_FILTER = {
  ALL: {
    name: "ALL",
    startDate: "all",
    endDate: "all",
  },
  Y1: {
    name: "Y1",
    startDate: new FilterDate(CURRENT_DATE).removeYear(1).toISOString(),
    endDate: CURRENT_DATE.toISOString(),
  },
  Y3: {
    name: "Y3",
    startDate: new FilterDate(CURRENT_DATE).removeYear(3).toISOString(),
    endDate: CURRENT_DATE.toISOString(),
  },
  YTD: {
    name: "YTD",
    startDate: CURRENT_YTD_DATE.toISOString(),
    endDate: CURRENT_DATE.toISOString(),
  },
  DEFAULT: {
    name: "DEFAULT",
    startDate: "all",
    endDate: "all",
  },
};

export class PerformanceFilters {
  init() {}
  getCurrentFilterConfig(filterValue) {
    const currentConfig = CHART_FILTER[filterValue];
    if (!currentConfig) {
      console.warn("Provided config is not supported, will be used DEFAULT");
      return CHART_FILTER["DEFAULT"];
    }
    return currentConfig;
  }
}

export class PerformanceDatepicker {
  create(options) {
    const datepickerElement = document.querySelector(config.datepicker);

    if (!datepickerElement) {
      console.warn("Performance chart datepicker element is missing");
      return;
    }

    const datepickerInstance = flatpickr(datepickerElement, {
      wrap: true,
      mode: "range",
      ...options,
      locale: pickerLocale,
    });

    this.datepickerInstance = datepickerInstance;

    return datepickerInstance;
  }

  formatDate(date) {
    return formatDateWithLocale(date, "d MMM y");
  }
}
